import gql from "graphql-tag"

const ALL_INVENTORIES = gql`
  query getInventories {
    getInventories {
      id
      name
      description
      address {
        country
        region
        postalCode
        city
        streetAddress
      }
      type
      created
      updated
    }
  }
`

export default ALL_INVENTORIES
